import { styled } from '@mui/system';
import styled2 from 'styled-components';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
	Callout,
	FlexContainer,
	MD_LG_SECTION_HEADER,
} from '@silverrailtech/srtlibrary';
import { limeGreen } from '../../../../../colors';

export const SpinnerWrapper = styled(FlexContainer)({
	height: '82px',
	width: '110px',
	'& > .spinner-padding': {
		paddingTop: '24px !important',
	},
});

export const SuspendedCallout = styled(Callout)({
	marginTop: '16px',
});

export const SuspendedText = styled('span')({
	fontWeight: '600',
});

export const DialogTitle = styled2.h2`
	margin: 0 0 16px 0;
	${MD_LG_SECTION_HEADER}
`;

export const SuccessIcon = styled(CheckCircleOutlineIcon)({
	color: limeGreen,
	width: '64px',
	height: '64px',
});
